// extracted by mini-css-extract-plugin
export default {"container":"SearchBar_container__qa6Ll","input":"SearchBar_input__Cm3N+","button":"SearchBar_button__f1qTJ","logo":"SearchBar_logo__jeI4G"};